// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Es6Promise from 'es6-promise'
Es6Promise.polyfill()

import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import flexible from '../static/js/flexible'
import 'element-ui/lib/theme-chalk/index.css';
import '../static/style.css'
import '../static/iconfont.css'
import MintUI from 'mint-ui'
import { Lazyload } from 'mint-ui';
import { InfiniteScroll } from 'mint-ui';
import 'mint-ui/lib/style.css'
import store from './store'
import * as filters from './custom/filters'
import axios from 'axios'
import url from './http/url.js'
import VueClipboard from 'vue-clipboard2'

import { Row, Col, Grid, GridItem, Panel } from 'vant';
import 'vant/lib/index.css';

// ------------new vant ------------
import { Icon, Cell, CellGroup, Button, Toast } from 'vant';
Vue.use(Icon);
Vue.use(Cell);
Vue.use(CellGroup);
// Vue.use(loading);
Vue.use(Button);
Vue.use(Toast);

// import vConsole from './utils/vconsole';
// import FastClick from 'fastclick'
import {getWxConfig} from "./http/getData";

Vue.use(Row).use(Col).use(Grid).use(GridItem).use(Panel);

Vue.use(ElementUI)
Vue.use(MintUI)
Vue.use(Lazyload);
Vue.use(InfiniteScroll);
Vue.use(VueClipboard)
Vue.config.productionTip = false
Vue.prototype.axios = axios.create({
  baseURL:url.baseUrl,
  timeout:5000
});
Vue.prototype.wxConfig = url => {
  return new Promise((resolve, reject)=>{
    getWxConfig({
      url:url
    }).then(response => {
      let config = {
        debug: false,
        appId: '',
        timestamp: '',
        nonceStr: '',
        signature: '',
        jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage", "onMenuShareQQ"]
      }
      config.appId = response.result.appId
      config.timestamp = response.result.timestamp
      config.nonceStr = response.result.nonceStr
      config.signature = response.result.signature
      resolve(config)
    },error => {
      reject(error)
    })
  })
}

Vue.config.devtools = true;
// FastClick.attach(document.body);

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!localStorage.token) {
      // 注意：原系统-mallindex优先，报单系统-vlogin优先
      next({
        path: '/login'
        // path: '/vlogin'
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js